import { api } from "../../api";
import { PLAYLIST_CATEGORY_ENDPOINTS } from "../../../constants/endpoints";

export const playlistCategoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllPlaylistCategories: builder.query({
      query: () => ({
        url: PLAYLIST_CATEGORY_ENDPOINTS.GET_ALL,
        method: "POST",
      }),
      providesTags: ["PlaylistCategory"],
    }),

    createPlaylistCategory: builder.mutation({
      query: (playlistCategory) => ({
        url: PLAYLIST_CATEGORY_ENDPOINTS.CREATE,
        method: "POST",
        body: playlistCategory,
      }),
      invalidatesTags: ["PlaylistCategory"],
    }),
    updatePlaylistCategory: builder.mutation({
      query: (body) => ({
        url: PLAYLIST_CATEGORY_ENDPOINTS.UPDATE,
        method: "POST",
        body,
      }),
      invalidatesTags: ["PlaylistCategory"],
    }),
    deletePlaylistCategory: builder.mutation({
      query: (id) => ({
        url: PLAYLIST_CATEGORY_ENDPOINTS.DELETE,
        method: "POST",
        body: { id },
      }),
      invalidatesTags: ["PlaylistCategory"],
    }),
    getPlaylistsByCategoryAndNetwork: builder.query({
      query: (categoryId) => ({
        url: PLAYLIST_CATEGORY_ENDPOINTS.GET_PLAYLISTS_BY_CATEGORY_AND_NETWORK,
        method: "POST",
        body:  categoryId ,
      }),
      providesTags: ["PlaylistCategory"], 
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllPlaylistCategoriesQuery,
  useCreatePlaylistCategoryMutation,
  useUpdatePlaylistCategoryMutation,
  useDeletePlaylistCategoryMutation,
  useGetPlaylistsByCategoryAndNetworkQuery
} = playlistCategoryApi;
